import { Warning } from "@mui/icons-material";
import { t } from "i18next";
import { ReactElement } from "react";
import { ArtType } from "../../../src/helpers/types";
import ElgIcon from "../../assets/img/elg.svg?react";
import HjortIcon from "../../assets/img/hjort.svg?react";
import RadyrIcon from "../../assets/img/radyr.svg?react";
import ReinsdyrIcon from "../../assets/img/reinsdyr.svg?react";
import VillsvinIcon from "../../assets/img/villsvin.svg?react";

//Icons used in the app

interface iconProps {
  className?: string;
  sizeClassName?: string;
  title?: string;
  ariaHidden?: boolean;
}

interface baseProps {
  children: ReactElement;
  iconProps: iconProps;
  height?: number;
  width?: number;
}

function BaseIcon({ children, height, width, iconProps }: baseProps) {
  return (
    <div
      className={`min-h-6 min-w-6 shrink-0 flex items-center justify-center ${iconProps.className}`}
    >
      <svg
        style={{ width: width, height: height }}
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? "24"}
        height={height ?? "24"}
        viewBox={`0 0 ${width ?? "24"} ${height ?? "24"}`}
        fill="currentColor"
        color="currentColor"
        role="graphics-symbol"
        className={iconProps.sizeClassName}
        aria-hidden={
          iconProps.ariaHidden != undefined ? iconProps.ariaHidden : iconProps.title === undefined
        }
      >
        {iconProps.title && <title>{iconProps.title}</title>}
        {children}
      </svg>
    </div>
  );
}

export function InfoIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props} height={20} width={20}>
      <path d="M8.83384 15H10.7405V9H8.83384V15ZM9.78719 7C10.0573 7 10.2837 6.90417 10.4665 6.7125C10.6492 6.52083 10.7405 6.28333 10.7405 6C10.7405 5.71667 10.6492 5.47917 10.4665 5.2875C10.2837 5.09583 10.0573 5 9.78719 5C9.51707 5 9.29065 5.09583 9.10793 5.2875C8.9252 5.47917 8.83384 5.71667 8.83384 6C8.83384 6.28333 8.9252 6.52083 9.10793 6.7125C9.29065 6.90417 9.51707 7 9.78719 7ZM9.78719 20C8.46838 20 7.22903 19.7375 6.06911 19.2125C4.9092 18.6875 3.90024 17.975 3.04222 17.075C2.1842 16.175 1.50494 15.1167 1.00443 13.9C0.503917 12.6833 0.253662 11.3833 0.253662 10C0.253662 8.61667 0.503917 7.31667 1.00443 6.1C1.50494 4.88333 2.1842 3.825 3.04222 2.925C3.90024 2.025 4.9092 1.3125 6.06911 0.7875C7.22903 0.2625 8.46838 0 9.78719 0C11.106 0 12.3454 0.2625 13.5053 0.7875C14.6652 1.3125 15.6741 2.025 16.5322 2.925C17.3902 3.825 18.0694 4.88333 18.57 6.1C19.0705 7.31667 19.3207 8.61667 19.3207 10C19.3207 11.3833 19.0705 12.6833 18.57 13.9C18.0694 15.1167 17.3902 16.175 16.5322 17.075C15.6741 17.975 14.6652 18.6875 13.5053 19.2125C12.3454 19.7375 11.106 20 9.78719 20ZM9.78719 18C11.9163 18 13.7198 17.225 15.1975 15.675C16.6752 14.125 17.414 12.2333 17.414 10C17.414 7.76667 16.6752 5.875 15.1975 4.325C13.7198 2.775 11.9163 2 9.78719 2C7.65804 2 5.85461 2.775 4.37691 4.325C2.89922 5.875 2.16037 7.76667 2.16037 10C2.16037 12.2333 2.89922 14.125 4.37691 15.675C5.85461 17.225 7.65804 18 9.78719 18Z" />
    </BaseIcon>
  );
}

export function InfoIconLarger(props: iconProps) {
  return (
    <BaseIcon iconProps={props} height={24} width={25}>
      <path
        d="M11.0534 18H13.4534V10.8H11.0534V18ZM12.2534 8.4C12.5934 8.4 12.8784 8.285 13.1084 8.055C13.3384 7.825 13.4534 7.54 13.4534 7.2C13.4534 6.86 13.3384 6.575 13.1084 6.345C12.8784 6.115 12.5934 6 12.2534 6C11.9134 6 11.6284 6.115 11.3984 6.345C11.1684 6.575 11.0534 6.86 11.0534 7.2C11.0534 7.54 11.1684 7.825 11.3984 8.055C11.6284 8.285 11.9134 8.4 12.2534 8.4ZM12.2534 24C10.5934 24 9.03342 23.685 7.57342 23.055C6.11342 22.425 4.84342 21.57 3.76342 20.49C2.68342 19.41 1.82842 18.14 1.19842 16.68C0.568418 15.22 0.253418 13.66 0.253418 12C0.253418 10.34 0.568418 8.78 1.19842 7.32C1.82842 5.86 2.68342 4.59 3.76342 3.51C4.84342 2.43 6.11342 1.575 7.57342 0.945C9.03342 0.315 10.5934 0 12.2534 0C13.9134 0 15.4734 0.315 16.9334 0.945C18.3934 1.575 19.6634 2.43 20.7434 3.51C21.8234 4.59 22.6784 5.86 23.3084 7.32C23.9384 8.78 24.2534 10.34 24.2534 12C24.2534 13.66 23.9384 15.22 23.3084 16.68C22.6784 18.14 21.8234 19.41 20.7434 20.49C19.6634 21.57 18.3934 22.425 16.9334 23.055C15.4734 23.685 13.9134 24 12.2534 24ZM12.2534 21.6C14.9334 21.6 17.2034 20.67 19.0634 18.81C20.9234 16.95 21.8534 14.68 21.8534 12C21.8534 9.32 20.9234 7.05 19.0634 5.19C17.2034 3.33 14.9334 2.4 12.2534 2.4C9.57342 2.4 7.30342 3.33 5.44342 5.19C3.58342 7.05 2.65342 9.32 2.65342 12C2.65342 14.68 3.58342 16.95 5.44342 18.81C7.30342 20.67 9.57342 21.6 12.2534 21.6Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}

export function WarningIcon(props: iconProps) {
  const iconProps = {
    ...props,
    title: props.title ?? t("actions.warning"),
    className: `text-ldir-orange-900 ${props.className ?? ""}`,
  };
  return (
    <BaseIcon iconProps={iconProps}>
      <path d="M11.9995 6C11.6595 6 11.3745 6.115 11.1445 6.345C10.9145 6.575 10.7995 6.86 10.7995 7.2C10.7995 7.54 10.9145 7.825 11.1445 8.055C11.3745 8.285 11.6595 8.4 11.9995 8.4C12.3395 8.4 12.6245 8.285 12.8545 8.055C13.0845 7.825 13.1995 7.54 13.1995 7.2C13.1995 6.86 13.0845 6.575 12.8545 6.345C12.6245 6.115 12.3395 6 11.9995 6ZM13.1995 10.8L10.7995 10.8L10.7995 18L13.1995 18L13.1995 10.8ZM11.9995 8.58275e-07C13.6595 1.0034e-06 15.2195 0.315002 16.6795 0.945001C18.1395 1.575 19.4095 2.43 20.4895 3.51C21.5695 4.59 22.4245 5.86 23.0545 7.32C23.6845 8.78 23.9995 10.34 23.9995 12C23.9995 13.66 23.6845 15.22 23.0545 16.68C22.4245 18.14 21.5695 19.41 20.4895 20.49C19.4095 21.57 18.1395 22.425 16.6795 23.055C15.2195 23.685 13.6595 24 11.9995 24C10.3395 24 8.77951 23.685 7.31951 23.055C5.85951 22.425 4.58951 21.57 3.50951 20.49C2.42951 19.41 1.57451 18.14 0.944508 16.68C0.314509 15.22 -0.000491192 13.66 -0.000491047 12C-0.000490902 10.34 0.31451 8.78 0.944509 7.32C1.57451 5.86 2.42951 4.59 3.50951 3.51C4.58951 2.43 5.85951 1.575 7.31951 0.945C8.77951 0.315001 10.3395 7.13153e-07 11.9995 8.58275e-07Z" />
    </BaseIcon>
  );
}

export function ErrorIcon(props: iconProps) {
  const iconProps = {
    ...props,
    title: props.title ?? t("actions.error"),
    className: props.className ?? "text-ldir-red-900",
  };
  return (
    <BaseIcon iconProps={iconProps} width={27} height={24}>
      <path
        d="M0 24L13.895 0L27.79 24H0ZM13.895 20.2105C14.2529 20.2105 14.5529 20.0895 14.795 19.8474C15.0371 19.6053 15.1582 19.3053 15.1582 18.9474C15.1582 18.5895 15.0371 18.2895 14.795 18.0474C14.5529 17.8053 14.2529 17.6842 13.895 17.6842C13.5371 17.6842 13.2371 17.8053 12.995 18.0474C12.7529 18.2895 12.6318 18.5895 12.6318 18.9474C12.6318 19.3053 12.7529 19.6053 12.995 19.8474C13.2371 20.0895 13.5371 20.2105 13.895 20.2105ZM12.6318 16.4211H15.1582V10.1053H12.6318V16.4211Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}

export function CompleteIcon(props: iconProps) {
  const iconProps = {
    ...props,
    className: `text-ldir-green-900 ${props.className ?? ""}`,
  };
  return (
    <BaseIcon iconProps={iconProps}>
      <path d="M10.32 17.52L18.78 9.06L17.1 7.38L10.32 14.16L6.9 10.74L5.22 12.42L10.32 17.52ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24Z" />
    </BaseIcon>
  );
}

export function AlertIcon(props: iconProps) {
  const iconProps = {
    ...props,
    title: props.title ?? t("actions.warning"),
    className: `${
      props.className
        ? props.className.includes("text")
          ? props.className
          : `text-ldir-red-900 ${props.className}`
        : "text-ldir-red-900"
    }`,
  };
  return (
    <BaseIcon iconProps={iconProps}>
      <path d="M12 18C12.34 18 12.625 17.885 12.855 17.655C13.085 17.425 13.2 17.14 13.2 16.8C13.2 16.46 13.085 16.175 12.855 15.945C12.625 15.715 12.34 15.6 12 15.6C11.66 15.6 11.375 15.715 11.145 15.945C10.915 16.175 10.8 16.46 10.8 16.8C10.8 17.14 10.915 17.425 11.145 17.655C11.375 17.885 11.66 18 12 18ZM10.8 13.2H13.2L13.2 6L10.8 6L10.8 13.2ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24Z" />
    </BaseIcon>
  );
}

export function CheckIcon(props: iconProps) {
  const iconProps = {
    ...props,
    className: `text-ldir-blue-900 ${props.className ?? ""}`,
  };
  return (
    <BaseIcon iconProps={iconProps} height={22} width={28}>
      <path
        d="M24.2578 1.64941L26.3564 3.78223L26.7012 4.13281L26.3564 4.4834L10.749 20.3506L10.3926 20.7129L10.0361 20.3506L1.64355 11.8184L1.29883 11.4678L1.64355 11.1172L3.74219 8.98438L4.09863 8.62207L4.45508 8.98438L10.3916 15.0195L23.5449 1.64941L23.9014 1.28711L24.2578 1.64941Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </BaseIcon>
  );
}

export function ArrowRightIcon(props: iconProps) {
  const iconProps = {
    ...props,
    className: `text-ldir-blue-900 ${props.className ?? ""}`,
  };
  return (
    <BaseIcon iconProps={iconProps} width={16} height={26}>
      <path
        d="M4.55859 2.33496L13.4746 12.335L14.0674 13L13.4746 13.665L4.55859 23.665L3.8125 24.5029L3.06641 23.665L2.25391 22.7539L1.66016 22.0889L2.25391 21.4229L9.7627 13L2.25391 4.57715L1.66016 3.91113L2.25391 3.24609L3.06641 2.33496L3.8125 1.49707L4.55859 2.33496Z"
        strokeWidth="2"
        stroke="currentColor"
      />
    </BaseIcon>
  );
}

export function AddButtonIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props} height={42} width={42}>
      <>
        <rect width="42" height="42" rx="10" fill="#007B97" />
        <path
          d="M19.8 27H22.2V22.2H27V19.8H22.2V15H19.8V19.8H15V22.2H19.8V27ZM21 33C19.34 33 17.78 32.685 16.32 32.055C14.86 31.425 13.59 30.57 12.51 29.49C11.43 28.41 10.575 27.14 9.94499 25.68C9.31499 24.22 8.99999 22.66 8.99999 21C8.99999 19.34 9.31499 17.78 9.94499 16.32C10.575 14.86 11.43 13.59 12.51 12.51C13.59 11.43 14.86 10.575 16.32 9.945C17.78 9.315 19.34 9 21 9C22.66 9 24.22 9.315 25.68 9.945C27.14 10.575 28.41 11.43 29.49 12.51C30.57 13.59 31.425 14.86 32.055 16.32C32.685 17.78 33 19.34 33 21C33 22.66 32.685 24.22 32.055 25.68C31.425 27.14 30.57 28.41 29.49 29.49C28.41 30.57 27.14 31.425 25.68 32.055C24.22 32.685 22.66 33 21 33ZM21 30.6C23.68 30.6 25.95 29.67 27.81 27.81C29.67 25.95 30.6 23.68 30.6 21C30.6 18.32 29.67 16.05 27.81 14.19C25.95 12.33 23.68 11.4 21 11.4C18.32 11.4 16.05 12.33 14.19 14.19C12.33 16.05 11.4 18.32 11.4 21C11.4 23.68 12.33 25.95 14.19 27.81C16.05 29.67 18.32 30.6 21 30.6Z"
          fill="#E3EDF0"
        />
      </>
    </BaseIcon>
  );
}

export function EditIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props}>
      <path d="M2.66667 21.3333H4.56667L17.6 8.3L15.7 6.4L2.66667 19.4333V21.3333ZM0 24V18.3333L17.6 0.766667C17.8667 0.522222 18.1611 0.333333 18.4833 0.2C18.8056 0.0666667 19.1444 0 19.5 0C19.8556 0 20.2 0.0666667 20.5333 0.2C20.8667 0.333333 21.1556 0.533333 21.4 0.8L23.2333 2.66667C23.5 2.91111 23.6944 3.2 23.8167 3.53333C23.9389 3.86667 24 4.2 24 4.53333C24 4.88889 23.9389 5.22778 23.8167 5.55C23.6944 5.87222 23.5 6.16667 23.2333 6.43333L5.66667 24H0ZM16.6333 7.36667L15.7 6.4L17.6 8.3L16.6333 7.36667Z" />
    </BaseIcon>
  );
}

export function ProfileIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props}>
      <path d="M12 12C10.35 12 8.9375 11.4125 7.7625 10.2375C6.5875 9.0625 6 7.65 6 6C6 4.35 6.5875 2.9375 7.7625 1.7625C8.9375 0.5875 10.35 0 12 0C13.65 0 15.0625 0.5875 16.2375 1.7625C17.4125 2.9375 18 4.35 18 6C18 7.65 17.4125 9.0625 16.2375 10.2375C15.0625 11.4125 13.65 12 12 12ZM0 24V19.8C0 18.95 0.21875 18.1688 0.65625 17.4563C1.09375 16.7438 1.675 16.2 2.4 15.825C3.95 15.05 5.525 14.4688 7.125 14.0813C8.725 13.6938 10.35 13.5 12 13.5C13.65 13.5 15.275 13.6938 16.875 14.0813C18.475 14.4688 20.05 15.05 21.6 15.825C22.325 16.2 22.9062 16.7438 23.3438 17.4563C23.7812 18.1688 24 18.95 24 19.8V24H0ZM3 21H21V19.8C21 19.525 20.9313 19.275 20.7938 19.05C20.6562 18.825 20.475 18.65 20.25 18.525C18.9 17.85 17.5375 17.3438 16.1625 17.0063C14.7875 16.6688 13.4 16.5 12 16.5C10.6 16.5 9.2125 16.6688 7.8375 17.0063C6.4625 17.3438 5.1 17.85 3.75 18.525C3.525 18.65 3.34375 18.825 3.20625 19.05C3.06875 19.275 3 19.525 3 19.8V21ZM12 9C12.825 9 13.5313 8.70625 14.1188 8.11875C14.7063 7.53125 15 6.825 15 6C15 5.175 14.7063 4.46875 14.1188 3.88125C13.5313 3.29375 12.825 3 12 3C11.175 3 10.4688 3.29375 9.88125 3.88125C9.29375 4.46875 9 5.175 9 6C9 6.825 9.29375 7.53125 9.88125 8.11875C10.4688 8.70625 11.175 9 12 9Z" />
    </BaseIcon>
  );
}

export function TargetIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props}>
      <path d="M12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24ZM12 21.6C14.68 21.6 16.95 20.67 18.81 18.81C20.67 16.95 21.6 14.68 21.6 12C21.6 9.32 20.67 7.05 18.81 5.19C16.95 3.33 14.68 2.4 12 2.4C9.32 2.4 7.05 3.33 5.19 5.19C3.33 7.05 2.4 9.32 2.4 12C2.4 14.68 3.33 16.95 5.19 18.81C7.05 20.67 9.32 21.6 12 21.6ZM12 19.2C10 19.2 8.3 18.5 6.9 17.1C5.5 15.7 4.8 14 4.8 12C4.8 10 5.5 8.3 6.9 6.9C8.3 5.5 10 4.8 12 4.8C14 4.8 15.7 5.5 17.1 6.9C18.5 8.3 19.2 10 19.2 12C19.2 14 18.5 15.7 17.1 17.1C15.7 18.5 14 19.2 12 19.2ZM12 16.8C13.32 16.8 14.45 16.33 15.39 15.39C16.33 14.45 16.8 13.32 16.8 12C16.8 10.68 16.33 9.55 15.39 8.61C14.45 7.67 13.32 7.2 12 7.2C10.68 7.2 9.55 7.67 8.61 8.61C7.67 9.55 7.2 10.68 7.2 12C7.2 13.32 7.67 14.45 8.61 15.39C9.55 16.33 10.68 16.8 12 16.8ZM12 14.4C11.34 14.4 10.775 14.165 10.305 13.695C9.835 13.225 9.6 12.66 9.6 12C9.6 11.34 9.835 10.775 10.305 10.305C10.775 9.835 11.34 9.6 12 9.6C12.66 9.6 13.225 9.835 13.695 10.305C14.165 10.775 14.4 11.34 14.4 12C14.4 12.66 14.165 13.225 13.695 13.695C13.225 14.165 12.66 14.4 12 14.4Z" />
    </BaseIcon>
  );
}

export function SearchIcon(props: iconProps) {
  const iconProps = {
    ...props,
    className: `text-ldir-blue-900 ${props.className ?? ""}`,
  };
  return (
    <BaseIcon iconProps={iconProps} height={26} width={26}>
      <path
        d="M23.1333 25L14.7333 16.6C14.0667 17.1333 13.3 17.5556 12.4333 17.8667C11.5667 18.1778 10.6444 18.3333 9.66667 18.3333C7.24444 18.3333 5.19444 17.4944 3.51667 15.8167C1.83889 14.1389 1 12.0889 1 9.66667C1 7.24444 1.83889 5.19444 3.51667 3.51667C5.19444 1.83889 7.24444 1 9.66667 1C12.0889 1 14.1389 1.83889 15.8167 3.51667C17.4944 5.19444 18.3333 7.24444 18.3333 9.66667C18.3333 10.6444 18.1778 11.5667 17.8667 12.4333C17.5556 13.3 17.1333 14.0667 16.6 14.7333L25 23.1333L23.1333 25ZM9.66667 15.6667C11.3333 15.6667 12.75 15.0833 13.9167 13.9167C15.0833 12.75 15.6667 11.3333 15.6667 9.66667C15.6667 8 15.0833 6.58333 13.9167 5.41667C12.75 4.25 11.3333 3.66667 9.66667 3.66667C8 3.66667 6.58333 4.25 5.41667 5.41667C4.25 6.58333 3.66667 8 3.66667 9.66667C3.66667 11.3333 4.25 12.75 5.41667 13.9167C6.58333 15.0833 8 15.6667 9.66667 15.6667Z"
        fill="currentColor"
        stroke="currentColor"
      />
    </BaseIcon>
  );
}

export function CloseIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props} height={20} width={20}>
      <path d="M2 20L0 18L8 10L0 2L2 0L10 8L18 0L20 2L12 10L20 18L18 20L10 12L2 20Z" />
    </BaseIcon>
  );
}

export function DeleteIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props} height={24} width={21}>
      <path d="M3.9375 24C3.21562 24 2.59766 23.7389 2.08359 23.2167C1.56953 22.6944 1.3125 22.0667 1.3125 21.3333V4H0V1.33333H6.5625V0H14.4375V1.33333H21V4H19.6875V21.3333C19.6875 22.0667 19.4305 22.6944 18.9164 23.2167C18.4023 23.7389 17.7844 24 17.0625 24H3.9375ZM17.0625 4H3.9375V21.3333H17.0625V4ZM6.5625 18.6667H9.1875V6.66667H6.5625V18.6667ZM11.8125 18.6667H14.4375V6.66667H11.8125V18.6667Z" />
    </BaseIcon>
  );
}

export function SaveIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props} height={20} width={20}>
      <path d="M20 4.44444V17.7778C20 18.3889 19.7824 18.912 19.3472 19.3472C18.912 19.7824 18.3889 20 17.7778 20H2.22222C1.61111 20 1.08796 19.7824 0.652778 19.3472C0.217593 18.912 0 18.3889 0 17.7778V2.22222C0 1.61111 0.217593 1.08796 0.652778 0.652778C1.08796 0.217593 1.61111 0 2.22222 0H15.5556L20 4.44444ZM17.7778 5.38889L14.6111 2.22222H2.22222V17.7778H17.7778V5.38889ZM10 16.6667C10.9259 16.6667 11.713 16.3426 12.3611 15.6944C13.0093 15.0463 13.3333 14.2593 13.3333 13.3333C13.3333 12.4074 13.0093 11.6204 12.3611 10.9722C11.713 10.3241 10.9259 10 10 10C9.07407 10 8.28704 10.3241 7.63889 10.9722C6.99074 11.6204 6.66667 12.4074 6.66667 13.3333C6.66667 14.2593 6.99074 15.0463 7.63889 15.6944C8.28704 16.3426 9.07407 16.6667 10 16.6667ZM3.33333 7.77778H13.3333V3.33333H3.33333V7.77778ZM2.22222 5.38889V17.7778V2.22222V5.38889Z" />
    </BaseIcon>
  );
}

export function CalendarIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props} height={20} width={20}>
      <path d="M5 12C4.71667 12 4.47917 11.9042 4.2875 11.7125C4.09583 11.5208 4 11.2833 4 11C4 10.7167 4.09583 10.4792 4.2875 10.2875C4.47917 10.0958 4.71667 10 5 10C5.28333 10 5.52083 10.0958 5.7125 10.2875C5.90417 10.4792 6 10.7167 6 11C6 11.2833 5.90417 11.5208 5.7125 11.7125C5.52083 11.9042 5.28333 12 5 12ZM9 12C8.71667 12 8.47917 11.9042 8.2875 11.7125C8.09583 11.5208 8 11.2833 8 11C8 10.7167 8.09583 10.4792 8.2875 10.2875C8.47917 10.0958 8.71667 10 9 10C9.28333 10 9.52083 10.0958 9.7125 10.2875C9.90417 10.4792 10 10.7167 10 11C10 11.2833 9.90417 11.5208 9.7125 11.7125C9.52083 11.9042 9.28333 12 9 12ZM13 12C12.7167 12 12.4792 11.9042 12.2875 11.7125C12.0958 11.5208 12 11.2833 12 11C12 10.7167 12.0958 10.4792 12.2875 10.2875C12.4792 10.0958 12.7167 10 13 10C13.2833 10 13.5208 10.0958 13.7125 10.2875C13.9042 10.4792 14 10.7167 14 11C14 11.2833 13.9042 11.5208 13.7125 11.7125C13.5208 11.9042 13.2833 12 13 12ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H3V0H5V2H13V0H15V2H16C16.55 2 17.0208 2.19583 17.4125 2.5875C17.8042 2.97917 18 3.45 18 4V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H2ZM2 18H16V8H2V18ZM2 6H16V4H2V6Z" />
    </BaseIcon>
  );
}

export function SyncIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props} height={24} width={17}>
      <path
        d="M1.16875 16.4182C0.779167 15.7273 0.486979 15.0182 0.292188 14.2909C0.0973958 13.5636 0 12.8182 0 12.0545C0 9.61818 0.823438 7.54545 2.47031 5.83636C4.11719 4.12727 6.12708 3.27273 8.5 3.27273H8.68594L6.98594 1.52727L8.47344 0L12.7234 4.36364L8.47344 8.72727L6.98594 7.2L8.68594 5.45455H8.5C6.72917 5.45455 5.22396 6.09545 3.98438 7.37727C2.74479 8.65909 2.125 10.2182 2.125 12.0545C2.125 12.5273 2.17812 12.9909 2.28437 13.4455C2.39062 13.9 2.55 14.3455 2.7625 14.7818L1.16875 16.4182ZM8.52656 24L4.27656 19.6364L8.52656 15.2727L10.0141 16.8L8.31406 18.5455H8.5C10.2708 18.5455 11.776 17.9045 13.0156 16.6227C14.2552 15.3409 14.875 13.7818 14.875 11.9455C14.875 11.4727 14.8219 11.0091 14.7156 10.5545C14.6094 10.1 14.45 9.65454 14.2375 9.21818L15.8313 7.58182C16.2208 8.27273 16.513 8.98182 16.7078 9.70909C16.9026 10.4364 17 11.1818 17 11.9455C17 14.3818 16.1766 16.4545 14.5297 18.1636C12.8828 19.8727 10.8729 20.7273 8.5 20.7273H8.31406L10.0141 22.4727L8.52656 24Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}

export function SyncErrorIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props}>
      <path
        d="M22.2749 24L18.6431 20.3682C17.7957 20.8928 16.8878 21.3014 15.9193 21.5939C14.9508 21.8865 13.9319 22.0328 12.8625 22.0328C11.3493 22.0328 9.9319 21.7453 8.61034 21.1702C7.28878 20.5952 6.13871 19.8184 5.16015 18.8398C4.18159 17.8613 3.40479 16.7112 2.82976 15.3897C2.25473 14.0681 1.96721 12.6507 1.96721 11.1375C1.96721 10.0681 2.11349 9.04918 2.40605 8.08071C2.69861 7.11223 3.10719 6.20429 3.63178 5.35687L0 1.72509L1.72509 0L24 22.2749L22.2749 24ZM12.8625 19.6116C13.5889 19.6116 14.29 19.5259 14.966 19.3544C15.6419 19.1828 16.2825 18.9357 16.8878 18.6129L5.38714 7.11223C5.06431 7.71753 4.81715 8.35813 4.64565 9.03405C4.47415 9.70996 4.3884 10.4111 4.3884 11.1375C4.3884 13.4981 5.21059 15.5006 6.85498 17.145C8.49937 18.7894 10.5019 19.6116 12.8625 19.6116ZM16.4943 8.71627V6.29508H19.8235C18.9962 5.1652 17.9773 4.27743 16.7667 3.63178C15.5561 2.98613 14.2547 2.6633 12.8625 2.6633C12.1362 2.6633 11.4351 2.74905 10.7591 2.92055C10.0832 3.09206 9.44262 3.33922 8.83733 3.66204L7.08197 1.90668C7.92938 1.38209 8.83733 0.973518 9.8058 0.680958C10.7743 0.388398 11.7932 0.242119 12.8625 0.242119C14.517 0.242119 16.0857 0.595208 17.5687 1.30139C19.0517 2.00757 20.3077 3.00631 21.3367 4.2976V1.45271H23.7579V8.71627H16.4943ZM14.0731 8.89786L11.652 6.47667V5.08449H14.0731V8.89786ZM22.0933 16.918L20.338 15.1627C20.5599 14.7188 20.7465 14.2648 20.8979 13.8008C21.0492 13.3367 21.1551 12.8525 21.2156 12.348H23.6974C23.5965 13.1955 23.4098 14.0025 23.1375 14.7692C22.8651 15.5359 22.517 16.2522 22.0933 16.918Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}

export function CancelIcon(props: iconProps) {
  return (
    <BaseIcon iconProps={props}>
      <path
        d="M7.04 16.5L11 12.54L14.96 16.5L16.5 14.96L12.54 11L16.5 7.04L14.96 5.5L11 9.46L7.04 5.5L5.5 7.04L9.46 11L5.5 14.96L7.04 16.5ZM11 22C9.47833 22 8.04833 21.7112 6.71 21.1337C5.37167 20.5562 4.2075 19.7725 3.2175 18.7825C2.2275 17.7925 1.44375 16.6283 0.86625 15.29C0.28875 13.9517 0 12.5217 0 11C0 9.47833 0.28875 8.04833 0.86625 6.71C1.44375 5.37167 2.2275 4.2075 3.2175 3.2175C4.2075 2.2275 5.37167 1.44375 6.71 0.86625C8.04833 0.28875 9.47833 0 11 0C12.5217 0 13.9517 0.28875 15.29 0.86625C16.6283 1.44375 17.7925 2.2275 18.7825 3.2175C19.7725 4.2075 20.5562 5.37167 21.1337 6.71C21.7112 8.04833 22 9.47833 22 11C22 12.5217 21.7112 13.9517 21.1337 15.29C20.5562 16.6283 19.7725 17.7925 18.7825 18.7825C17.7925 19.7725 16.6283 20.5562 15.29 21.1337C13.9517 21.7112 12.5217 22 11 22ZM11 19.8C13.4567 19.8 15.5375 18.9475 17.2425 17.2425C18.9475 15.5375 19.8 13.4567 19.8 11C19.8 8.54333 18.9475 6.4625 17.2425 4.7575C15.5375 3.0525 13.4567 2.2 11 2.2C8.54333 2.2 6.4625 3.0525 4.7575 4.7575C3.0525 6.4625 2.2 8.54333 2.2 11C2.2 13.4567 3.0525 15.5375 4.7575 17.2425C6.4625 18.9475 8.54333 19.8 11 19.8Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}

export const artIcon = (art: ArtType, small?: boolean): JSX.Element => {
  switch (art) {
    case ArtType.Elg:
      return <ElgIcon className={small ? "w-7 h-7" : "w-8.75 h-8.75"} />;
    case ArtType.Hjort:
      return <HjortIcon className={small ? "w-7 h-7" : "w-8.75 h-8.75"} />;
    case ArtType.Rådyr:
      return <RadyrIcon className={small ? "w-7 h-7" : "w-8.75 h-8.75"} />;
    case ArtType.Villrein:
      return <ReinsdyrIcon className={small ? "w-7 h-7" : "w-8.75 h-8.75 -mr-0.5"} />;
    case ArtType.Villsvin:
      return <VillsvinIcon className={small ? "w-7 h-7" : "w-8.75 h-8.75"} />;
  }
};

export const ArtIcons = ({
  JaktPåHjort,
  JaktPåElg,
  JaktPåRådyr,
  JaktPåVillrein,
  JaktPåVillsvin,
  small,
}: {
  JaktPåHjort?: boolean;
  JaktPåElg?: boolean;
  JaktPåRådyr?: boolean;
  JaktPåVillrein?: boolean;
  JaktPåVillsvin?: boolean;
  small?: boolean;
}): JSX.Element => {
  return (
    <div className="flex flex-row items-center">
      {JaktPåHjort && artIcon(ArtType.Hjort, small)}
      {JaktPåElg && artIcon(ArtType.Elg, small)}
      {JaktPåRådyr && artIcon(ArtType.Rådyr, small)}
      {JaktPåVillrein && artIcon(ArtType.Villrein, small)}
      {JaktPåVillsvin && artIcon(ArtType.Villsvin, small)}
    </div>
  );
};
